// Re-export for backward compatibility
export { addWebVitalsScript } from "./webVitalsImpl";

/**
 * Conditionally loads web vitals script as a chunk for 10% of users
 * Uses sessionStorage to track if already loaded to avoid reloading
 * Only downloads the chunk if user falls into the 10% sample
 */
export const conditionallyLoadWebVitals = async () => {
  // Check if running on client side
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }

  const SAMPLE_PERCENTAGE = 1; // 100%

  // Randomly decide if user falls into 10% sample (client-side decision)
  const isInSample = Math.random() <= SAMPLE_PERCENTAGE;

  if (!isInSample) {
    console.log("User not in sample, not loading web vitals");
    return;
  }

  try {
    // Dynamically import the web vitals implementation as a chunk
    const { addWebVitalsScript } = await import(
      /* webpackChunkName: "web-vitals-chunk" */
      "./webVitalsImpl"
    );

    // Call the function
    addWebVitalsScript();

    // Mark as loaded in sessionStorage to prevent reloading
  } catch (error) {
    console.error("Failed to load web vitals chunk:", error);
  }
};
